export const duplicationTranslations = {
  de: {
    action: 'Duplizieren',
    articleTitle: 'Artikel duplizieren',
    articleHint:
      'Eine neue Artikelnummer ist erforderlich. Stammdaten, allgemeine Staffelpreise und Gebinde werden vorbelegt; GTINs, Bestände, Chargen, Bilder und Historien werden nicht kopiert.',
    numberHint:
      'Neue, eindeutige Artikelnummer eingeben. Die Nummer des Originals ist nicht zulässig.',
    numberRequired: 'Für die Kopie ist eine neue Artikelnummer erforderlich.',
    differentNumber: 'Bitte eine andere Artikelnummer als beim Original eingeben.',
    numberTaken: 'Diese Artikelnummer ist bereits vergeben. Bitte eine andere wählen.',
    partnerTitle: 'Geschäftspartner duplizieren',
    partnerHint:
      'Prüfen und bearbeiten Sie die kopierten Stammdaten und Konditionen. Beim Speichern entsteht eine neue Partnernummer. Ansprechpartner, Zusatzadressen, Historien, Zustimmungen, Portalzugänge, Bankdaten und Finanzsalden werden nicht übernommen.',
    invoiceTitle: 'Rechnung als neuen Entwurf kopieren',
    invoiceHint:
      'Prüfen Sie Kunde, Anschriften, Preise und Leistungsdatum. Das Belegdatum ist neu; Nummer und Entwurf entstehen erst beim Speichern. Zahlungen, Buchungen und Chargenzuordnungen werden nicht kopiert. Bei Fremdwährung einen aktuellen Kurs mit Quelle angeben.',
    loadError: 'Die Kopie konnte nicht vorbereitet werden.',
    invoiceOnly: 'Als Rechnungsvorlage muss eine zugängliche Rechnung ausgewählt sein.',
  },
  en: {
    action: 'Duplicate',
    articleTitle: 'Duplicate product',
    articleHint:
      'A new article number is required. Master data, general quantity prices and packaging are prefilled; GTINs, stock, batches, images and history are excluded.',
    numberHint: 'Enter a new, unique article number. The original number cannot be used.',
    numberRequired: 'A new article number is required for the copy.',
    differentNumber: 'Enter an article number different from the original.',
    numberTaken: 'This article number is already in use. Choose another.',
    partnerTitle: 'Duplicate business partner',
    partnerHint:
      'Review and edit the copied master data and terms. Saving assigns a new partner number. Contacts, additional addresses, history, consent, portal access, bank details and financial balances are excluded.',
    invoiceTitle: 'Copy invoice as a new draft',
    invoiceHint:
      'Review the customer, addresses, prices and service date. The document date is new; a number and draft are created only on saving. Payments, journal entries and batch assignments are excluded. Enter a current rate and source for foreign currency.',
    loadError: 'The copy could not be prepared.',
    invoiceOnly: 'Choose an accessible invoice as the source.',
  },
  fr: {
    action: 'Dupliquer',
    articleTitle: 'Dupliquer un article',
    articleHint:
      'Un nouveau numéro est obligatoire. Les données de base, tarifs généraux par quantité et conditionnements sont préremplis ; GTIN, stocks, lots, images et historiques sont exclus.',
    numberHint: 'Saisissez un nouveau numéro d’article unique. Le numéro original est interdit.',
    numberRequired: 'Un nouveau numéro d’article est obligatoire pour la copie.',
    differentNumber: 'Saisissez un numéro différent de celui de l’original.',
    numberTaken: 'Ce numéro est déjà utilisé. Choisissez-en un autre.',
    partnerTitle: 'Dupliquer un partenaire',
    partnerHint:
      'Vérifiez les données et conditions copiées. L’enregistrement attribue un nouveau numéro. Interlocuteurs, adresses supplémentaires, historiques, consentements, accès portail, coordonnées bancaires et soldes sont exclus.',
    invoiceTitle: 'Copier la facture comme nouveau brouillon',
    invoiceHint:
      'Vérifiez client, adresses, prix et date de prestation. La date du document est nouvelle ; numéro et brouillon sont créés uniquement à l’enregistrement. Paiements, écritures et lots sont exclus. Pour une devise étrangère, indiquez un cours actuel et sa source.',
    loadError: 'La copie n’a pas pu être préparée.',
    invoiceOnly: 'Choisissez une facture accessible comme modèle.',
  },
  es: {
    action: 'Duplicar',
    articleTitle: 'Duplicar artículo',
    articleHint:
      'Se requiere un nuevo número de artículo. Se rellenan datos maestros, precios generales por cantidad y embalajes; se excluyen GTIN, existencias, lotes, imágenes e historial.',
    numberHint: 'Introduzca un número de artículo nuevo y único. No se admite el original.',
    numberRequired: 'La copia requiere un nuevo número de artículo.',
    differentNumber: 'Introduzca un número de artículo diferente del original.',
    numberTaken: 'Este número ya está en uso. Elija otro.',
    partnerTitle: 'Duplicar socio comercial',
    partnerHint:
      'Revise los datos maestros y condiciones copiados. Al guardar se asigna otro número. Se excluyen contactos, direcciones adicionales, historial, consentimientos, accesos al portal, datos bancarios y saldos.',
    invoiceTitle: 'Copiar factura como nuevo borrador',
    invoiceHint:
      'Revise cliente, direcciones, precios y fecha de servicio. La fecha del documento es nueva; número y borrador se crean al guardar. Se excluyen pagos, asientos y lotes. Para divisas, indique un cambio actual y su fuente.',
    loadError: 'No se pudo preparar la copia.',
    invoiceOnly: 'Seleccione una factura accesible como origen.',
  },
  tr: {
    action: 'Çoğalt',
    articleTitle: 'Ürünü çoğalt',
    articleHint:
      'Yeni ürün numarası zorunludur. Ana veriler, genel miktar fiyatları ve ambalajlar doldurulur; GTIN, stok, parti, görsel ve geçmiş kopyalanmaz.',
    numberHint: 'Yeni ve benzersiz bir ürün numarası girin. Asıl numara kullanılamaz.',
    numberRequired: 'Kopya için yeni ürün numarası zorunludur.',
    differentNumber: 'Asıl üründen farklı bir numara girin.',
    numberTaken: 'Bu ürün numarası kullanılıyor. Başka bir numara seçin.',
    partnerTitle: 'İş ortağını çoğalt',
    partnerHint:
      'Kopyalanan ana verileri ve koşulları kontrol edin. Kaydederken yeni numara atanır. İlgili kişiler, ek adresler, geçmiş, izinler, portal erişimi, banka bilgileri ve mali bakiyeler kopyalanmaz.',
    invoiceTitle: 'Faturayı yeni taslak olarak kopyala',
    invoiceHint:
      'Müşteri, adres, fiyat ve hizmet tarihini kontrol edin. Belge tarihi yenidir; numara ve taslak yalnızca kaydederken oluşur. Ödemeler, muhasebe kayıtları ve parti atamaları kopyalanmaz. Yabancı para için güncel kur ve kaynağını girin.',
    loadError: 'Kopya hazırlanamadı.',
    invoiceOnly: 'Kaynak olarak erişilebilir bir fatura seçin.',
  },
} as const;
